import React from "react"
import styles from "./styles.scss"
import Category from "./Category"
import IconBox from "components/IconBox"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Link } from "react-router-dom"
import { companySearchPath } from "utils/paths"

class Company extends React.Component {
  render() {
    const { company } = this.props
    return (
      <Link to={companySearchPath(company.id)} className={styles.container}>
        {company.logoUrl ? (
          <div
            className={styles.logo}
            style={{ backgroundImage: `url(${company.logoUrl})` }}
          />
        ) : (
          <div className={styles.icon}>
            <FontAwesomeIcon icon="wrench" />
          </div>
        )}

        <div className={styles.contentWrapper}>
          <div className={styles.wrapper}>
            <h2 className={styles.header}>{company.name}</h2>

            <div className={styles.categoriesWrapper}>
              {company.companyCategories.map(category => (
                <Category key={category.categoryId}>
                  {" "}
                  <p>{category.name}</p>{" "}
                </Category>
              ))}
            </div>
            <IconBox icon="phone" text={company.phone} />
            <IconBox icon="envelope" text={company.email} />
          </div>
        </div>
      </Link>
    )
  }
}

export default Company



// WEBPACK FOOTER //
// src/pages/CompanyIndex/Companies/Company/index.jsx